/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadFunctionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UploadFunctionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UploadFunctionsSecurity = {
  option1?: UploadFunctionsSecurityOption1 | undefined;
  option2?: UploadFunctionsSecurityOption2 | undefined;
};

export type UploadFunctionsRequest = {
  contentLength: number;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  requestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export type UploadFunctionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UploadFunctionsSecurityOption1$outboundSchema: z.ZodMiniType<
  UploadFunctionsSecurityOption1$Outbound,
  UploadFunctionsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadFunctionsSecurityOption1ToJSON(
  uploadFunctionsSecurityOption1: UploadFunctionsSecurityOption1,
): string {
  return JSON.stringify(
    UploadFunctionsSecurityOption1$outboundSchema.parse(
      uploadFunctionsSecurityOption1,
    ),
  );
}

/** @internal */
export type UploadFunctionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UploadFunctionsSecurityOption2$outboundSchema: z.ZodMiniType<
  UploadFunctionsSecurityOption2$Outbound,
  UploadFunctionsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadFunctionsSecurityOption2ToJSON(
  uploadFunctionsSecurityOption2: UploadFunctionsSecurityOption2,
): string {
  return JSON.stringify(
    UploadFunctionsSecurityOption2$outboundSchema.parse(
      uploadFunctionsSecurityOption2,
    ),
  );
}

/** @internal */
export type UploadFunctionsSecurity$Outbound = {
  Option1?: UploadFunctionsSecurityOption1$Outbound | undefined;
  Option2?: UploadFunctionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UploadFunctionsSecurity$outboundSchema: z.ZodMiniType<
  UploadFunctionsSecurity$Outbound,
  UploadFunctionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UploadFunctionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UploadFunctionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function uploadFunctionsSecurityToJSON(
  uploadFunctionsSecurity: UploadFunctionsSecurity,
): string {
  return JSON.stringify(
    UploadFunctionsSecurity$outboundSchema.parse(uploadFunctionsSecurity),
  );
}

/** @internal */
export type UploadFunctionsRequest$Outbound = {
  "Content-Length": number;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RequestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export const UploadFunctionsRequest$outboundSchema: z.ZodMiniType<
  UploadFunctionsRequest$Outbound,
  UploadFunctionsRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    requestBody: z.union([
      z.custom<ReadableStream<Uint8Array>>(x => x instanceof ReadableStream),
      z.custom<Blob>(x => x instanceof Blob),
      z.custom<ArrayBuffer>(x => x instanceof ArrayBuffer),
      z.custom<Uint8Array>(x => x instanceof Uint8Array),
    ]),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      requestBody: "RequestBody",
    });
  }),
);

export function uploadFunctionsRequestToJSON(
  uploadFunctionsRequest: UploadFunctionsRequest,
): string {
  return JSON.stringify(
    UploadFunctionsRequest$outboundSchema.parse(uploadFunctionsRequest),
  );
}
